// Module
var code = "<template> <require from=\"./toast-footer.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;